<div class="d-flex justify-content-between notMobile">
    <div class="flex-item m-2">
        <p-button styleClass="btn-primary me-2 p-button-sm" (onClick)="goHome();"><i class="fas fa-home me-2"></i> Home</p-button>
        <p-button styleClass="btn-primary me-2 p-button-sm" (onClick)="goAdvSearch();"><i class="fa-brands fa-searchengin me-2"></i> Advanced
            Search</p-button>
        <p-button styleClass="btn-primary me-2 p-button-sm" (onClick)="loadSearch();"><i class="pi pi-upload me-2"></i> Load Saved
            Search</p-button>
        <p-splitButton label="Quick Searches" icon="fas fa-calendar" [model]="quickSearchItems"
            styleClass="p-button-primary p-button-sm me-2" id="quickSearchBtn" label="Quick Searches" expandAriaLabel="More options for Quick Search Items"></p-splitButton>
    </div>
    <diV class="flex-item m-2">
        <p-splitButton label="Help & Info" icon="fas fa-circle-question" [model]="helpInfoItems"
            styleClass="p-button-accent p-button-sm" id="helpBtn" label="Help & Info" expandAriaLabel="More options for Help Info Items"></p-splitButton>
    </diV>
</div>
<div class="forMobile"><p-menubar [model]="navItems"></p-menubar></div>
<app-search-load-dialog [loadSearchVisible]="loadSearchVisible" (loadSearch)="executeLoadSearch($event)"
  (closeLoadSearch)="closeLoadSearch();"></app-search-load-dialog>